export const messages = {
  en: {
    assetInventory: {
      page: {
        title: 'New Inventory',
        subtitle: 'Select storehouse items and submit inventory',
        empty: 'No inventory items selected'
      },
      title: 'Asset Inventory',
      name: 'Inventory Name',
      namePlaceholder: 'Required, please enter inventory name',
      staffName: 'Inventory Staff',
      staffNamePlaceholder: 'Required, please enter inventory staff name',
      storehouse: 'Storehouse',
      storehousePlaceholder: 'Please select storehouse',
      invTime: 'Inventory Time',
      invTimePlaceholder: 'Required, please select inventory time',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please enter remark',
      itemInfo: 'Item Information',
      selectItem: 'Select Items',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      isFixed: 'Is Fixed',
      referencePrice: 'Reference Price',
      selectPrice: 'Please select price',
      stock: 'Stock',
      afterQuantity: 'After Quantity',
      afterQuantityPlaceholder: 'Required, please enter quantity after inventory',
      operation: 'Operation',
      remove: 'Remove',
      cancel: 'Cancel',
      submit: 'Submit',
      validateError: 'Please complete all required fields',
      selectItemError: 'Please select at least one item',
      selectPriceError: 'Please select price for all items',
      quantityError: 'Please enter valid quantity for all items',
      nameRequired: 'Inventory name is required',
      staffNameRequired: 'Inventory staff is required',
      storehouseRequired: 'Storehouse is required',
      invTimeRequired: 'Inventory time is required',
      remarkRequired: 'Remark is required',
      selectStorehouseFirst: 'Please select storehouse first',
      saveError: 'Failed to save inventory'
    },
   
  },
  zh: {
    assetInventory: {
      page: {
        title: '发起盘点',
        subtitle: '选择仓库物品并提交盘点',
        empty: '暂未选择盘点物品'
      },
      title: '资产盘点',
      name: '盘点名称',
      namePlaceholder: '必填，请填写盘点名称',
      staffName: '盘点人',
      staffNamePlaceholder: '必填，请填写盘点人',
      storehouse: '选择仓库',
      storehousePlaceholder: '请选择仓库',
      invTime: '盘点日期',
      invTimePlaceholder: '必填，请填写盘点日期',
      remark: '盘点说明',
      remarkPlaceholder: '必填，请填写盘点说明',
      itemInfo: '物品信息',
      selectItem: '选择物品',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      isFixed: '是否是固定物品',
      referencePrice: '参考价格',
      selectPrice: '请选择价格',
      stock: '物品库存',
      afterQuantity: '盘点后数量',
      afterQuantityPlaceholder: '必填，请填盘点后数量',
      operation: '操作',
      remove: '移除',
      cancel: '取消',
      submit: '提交',
      validateError: '请完成所有必填项',
      selectItemError: '请至少选择一件物品',
      selectPriceError: '请为所有物品选择价格',
      quantityError: '请为所有物品输入有效数量',
      nameRequired: '盘点名称不能为空',
      staffNameRequired: '盘点人不能为空',
      storehouseRequired: '请选择仓库',
      invTimeRequired: '盘点日期不能为空',
      remarkRequired: '盘点说明不能为空',
      selectStorehouseFirst: '请先选择仓库',
      saveError: '保存盘点失败'
    },
   
  }
}